import { DatePicker, DatePickerProps, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment, { Moment } from 'moment-timezone'
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form'

const dateFormat = 'YYYY-MM-DD'

type Props<T extends FieldValues> = {
  name: Path<T>
  label?: string
  required?: boolean
} & Pick<DatePickerProps<Moment>, 'autoFocus' | 'disabled' | 'format'>

export function RHFDatePicker<T extends FieldValues>({ name, label, required, ...props }: Props<T>) {
  const { control } = useFormContext<T>()

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState }) => (
          <DatePicker
            label={label}
            {...field}
            format={dateFormat}
            value={field.value ? moment(field.value) : null}
            onChange={(date) => {
              try {
                const val = date ? date.format(dateFormat) : null
                field.onChange(val)
              } catch {
                field.onChange(null)
              }
            }}
            slotProps={{
              textField: {
                variant: 'standard',
                size: 'small',
                required,
                InputLabelProps: { shrink: true },
                error: !!fieldState.error,
                helperText: fieldState.error?.message,
                fullWidth: true,
                inputProps: {
                  'aria-label': name,
                },
                sx: { mb: 2 },
              },
            }}
            {...props}
          />
        )}
      />
    </LocalizationProvider>
  )
}
